import { NONE_FILTER } from '@/constants/filters'

// Shared "not set" filter option, used by tables that let users filter on missing type/carrier_type values.
export default {
  computed: {
    notSetOption() {
      return { text: this.$t('order.notSet'), value: NONE_FILTER }
    },
  },
}
